import {Answer} from 'Models'
import {meetsThreshold} from "../_common/answerValidationHelper";
import head from 'ramda/es/head'
import equals from 'ramda/es/equals'

const log = x => { console.warn(x); return x }

export default class DnD1u1ZuordnungenValidator {
    static isAnswerCorrect(answer) {
        const userInput         = answer.userInput()
        const expectedAnswers   = answer.correctAnswers() // = [{ "?":["x", "y"] }, ...]
        const question          = answer.question()
        const isCountPerAnswer  = question.countPerAnswer()

        if(!userInput || userInput.length<1)
            return false

        const answers           = head(userInput).value.answerData
        const results           = expectedAnswers.map( ea => head(answers[ea.gegeben]) === ea.erwartet )
        const correctTasks      = () => results.filter(equals(true))

        return !isCountPerAnswer ? results.every( equals(true) )
                                 : meetsThreshold(correctTasks().length, results.length)
    }
}